<template>
  <div
    :class="{ backdrop: true, 'backdrop--center-content': centerContent }"
    @click.self="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script>
import { findFocusableElements } from '../directives/focus';

function getElementSiblings(el) {
  const siblings = [];
  let current = el.parentElement.firstElementChild;
  do {
    if (current !== el) siblings.push(current);
  } while ((current = current.nextElementSibling));
  return siblings;
}

export default {
  props: {
    centerContent: Boolean,
  },
  methods: {
    handleClick() {
      this.$emit('close');
    },
  },
  beforeMount() {
    // save focused element
    if (document.activeElement) {
      this.prevActiveElement = document.activeElement;
      document.activeElement.blur();
    }
  },
  mounted() {
    // disable scroll on body
    this.prevOverflow = window.document.documentElement.style.overflow;
    window.document.documentElement.style.overflow = 'hidden';
    // hide background content for screen readers
    this.hiddenElements = getElementSiblings(this.$el);
    this.hiddenElements.forEach((el) => el.setAttribute('aria-hidden', true));
  },
  destroyed() {
    // focus saved element
    if (this.prevActiveElement && this.prevActiveElement !== document.body) {
      this.prevActiveElement.focus();
    } else {
      const { first: firstFocusableElement } = findFocusableElements(
        document.body
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }
    // restore scroll
    window.document.documentElement.style.overflow = this.prevOverflow;
    // restore accessibility
    this.hiddenElements.forEach((el) => el.removeAttribute('aria-hidden'));
  },
};
</script>

<style>
.backdrop {
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 102; /* greater than stickies */
}
.backdrop--center-content {
  align-items: center;
  display: flex;
  justify-content: center;
}
</style>
